module.exports = __webpack_public_path__ + "img/approved-img.264f26f7.png";